// Compiled at 2026-10-07T06:21:14.844Z
// Auto-generated by Lowgile
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { System, System as This } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";

const Translations = { "English": {} } as const, $LabelIds = [] as const;
for (const obj of Object.values(Translations)) {
    for (const label in obj) {
        if (obj[label] instanceof Function) obj[label].toString = obj[label].toJSON = function() { return this() }

    }

}

let T = Translations['English'];
export const $T = new Proxy({}, {
    get(target, p) { return getLabel(p.toString()) },
    getOwnPropertyDescriptor(target, p) { return { configurable: true, enumerable: true } },
    ownKeys(target) { return Reflect.ownKeys(Translations[Sys.Language.language]) },
}) as TType, $T_English = Translations['English'], $Languages = { "English": "English" } as const;

export type TType = typeof Translations[keyof typeof Translations] & { [key: string]: any };

function getLabel(label: string) {
    const language = Sys.Language.language
    let translation = Translations[language]?.[label]
    const defaultLanguage = Sys.Language.defaultLanguage
    const translationInDefaultLanguage = Translations[defaultLanguage]?.[label]
    if (Sys.Language.editMode) {
        if (translation) {
            const allTranslations = Object.entries(Translations).map(([lang, translations]) => `${lang}: ${translations[label]}`).join('&#013;')
            const title = `Label ${label}&#013;&#013;${allTranslations}`.replaceAll('"', '&quot;')
            return `<span role="translateLabel:System.${label}" class="translation" title="${title}">${translation}</span>`
        }
        if (translationInDefaultLanguage) {
            return `<span role="translateLabel:System.${label}" class="translation translation-default-language" title="Label ${label} in default language (${defaultLanguage})">${translationInDefaultLanguage}</span>`
        }
    }
    if (translation) return translation
    if (translationInDefaultLanguage) return translationInDefaultLanguage
    if (label == '__type') return undefined // otherwise it interferes with loading of known types for jsonMapper
    return `<span role="translateLabel:System.${label}" class="translation translation-missing" title="Label ${label}">${label}</span>`
}
